import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {
  private host = environment.apiUrlHost;
  private configData: any
  constructor(private http: HttpClient) { }

  public addConfig(configData: any): Observable<any | HttpErrorResponse> {
    return this.http.post<any>(`${this.host}/CP/save-theme-config/`, configData)
  }

  getConfig(): Observable<any | HttpErrorResponse> {
    const configUrl = `${this.host}/CP/save-theme-config/`;
    if (this.configData) {
      // If config data already exists, return it without making a new HTTP request
      return of(this.configData);
    } else {
      // If config data doesn't exist, fetch it from the server
      return this.http.get<any>(configUrl).pipe(
        tap(data => this.configData = data), // Cache the fetched config data
        catchError(this.handleError<any>('getConfig', []))
      );
    }
  }

  getDataS3File(): Observable<any | HttpErrorResponse> {
    const configUrl = `${this.host}/CP/save-theme-config/`;
      return this.http.get<any>(configUrl).pipe(
        tap(data => this.configData = data), // Cache the fetched config data
        catchError(this.handleError<any>('getConfig', []))
      );

  }

  // Error handling
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      // Let the app keep running by returning an empty result.
      return of(result );
    };
  }

  loadConfig(): Observable<any> {
    return this.http.get(`${this.host}/CP/save-theme-config/`).pipe(
      tap(config => this.configData = config)
    );
  }
}
